// extracted by mini-css-extract-plugin
export default {"wrapper":"GCIClient_wrapper__RrbDL","licenseTXT":"GCIClient_licenseTXT__ZLM3D"};